import React, { FC } from "react"
import { CardProps } from "./Card.types"

import "./Card.scss"
import { Logo } from "../../Elements"

const Card: FC<CardProps> = ({
    header,
    children,
    className,
    showLogo,
    renderHeader,
    ...htmlProps
}: CardProps) => {
    const klass = `zb-card ${className || ""}`

    const defaultRenderHeader = () => (
        <h2 className="zb-card-header-title">{header}</h2>
    )

    return (
        <section className={klass} {...htmlProps}>
            {header && (
                <header className="zb-card-header">
                    {renderHeader
                        ? renderHeader(header)
                        : defaultRenderHeader()}
                    {showLogo && <Logo />}
                </header>
            )}
            {children}
        </section>
    )
}

export default Card
